import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'rm-web-template',
  template: `    
    <div class="website">
      <p>{{title}}</p>
      <div href=""><img class="site-image" [src]="imgUrl" alt="image"></div>
      <!--<p class="description">{{desc}}</p>-->
    </div>
  `,
  styleUrls: ['./web-template.component.scss']
})
export class WebTemplateComponent implements OnInit {
  @Input() title: string;
  @Input() imgUrl: string;
  @Input() desc: string;

  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/web-template/web-template.component.ts